var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { PIXABAY, UNSPLASH } from '@/helper/const';
import MediaServices from '@/services/MediaService';
import { Download01Icon, FolderIcon, Link02Icon, TextInputIcon, Trash01Icon, } from '@gohighlevel/ghl-icons/24/outline';
import { renderIcon, UIActionDropdown, UITable, UITextSmMedium, } from '@gohighlevel/ghl-ui';
import { computed, h } from 'vue';
import { useI18n } from 'vue-i18n';
import 'vue-simple-context-menu/dist/vue-simple-context-menu.css';
import useEmitter from '../composable/useEmitter';
import { useEvent } from '../composable/useEvent';
import { useStore } from '../store';
import { copyToClipboard, downloadFile, formatBits, formatDate, } from '../util/helper';
import NoFile from './NoFile.vue';
import TableImage from './TableImage.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'TableView',
    props: {
        files: { default: () => [] },
        mediaLayout: {},
        count: {},
        type: {}
    },
    emits: ["pageChange"],
    setup(__props, { emit: __emit }) {
        const emitter = useEmitter();
        const store = useStore();
        const props = __props;
        const loading = computed(() => store.loading);
        const emit = __emit;
        const { sendNotification } = useEvent();
        const { t } = useI18n();
        function onActionsClick(e, d) {
            return __awaiter(this, void 0, void 0, function* () {
                if (e === 'getLink') {
                    if (props.type === 'file' || props.type === 'static') {
                        copyToClipboard(d.url);
                    }
                    else if (props.type === PIXABAY) {
                        copyToClipboard(d.previewURL);
                    }
                    else if (props.type === UNSPLASH) {
                        copyToClipboard(d.urls.regular);
                    }
                    sendNotification({
                        title: t('common.copiedClipboard'),
                        type: 'success',
                    });
                }
                else if (e === 'delete') {
                    emitter.emit('deleteFileFolder', d);
                }
                else if (e === 'moveFolder') {
                    emitter.emit('moveItem', d);
                }
                else if (e === 'rename') {
                    emitter.emit('renameObject', d);
                }
                else if (e === 'download') {
                    sendNotification({
                        title: t('common.downloadInProgress'),
                        type: 'success',
                    });
                    const isDownloaded = yield downloadFile({
                        fileUrl: d.url,
                        name: d.name,
                        openFileInNewTab: true,
                    });
                    if (!isDownloaded)
                        sendNotification({
                            title: t('common.downloadFailed'),
                            type: 'error',
                        });
                }
                else if (e === 'addImageToMedia') {
                    const params = {
                        altId: store.altId,
                        altType: store.altType,
                        mode: store.mode,
                    };
                    params.extraParams = {
                        mode: store.mode,
                    };
                    if (props.type === UNSPLASH) {
                        params.url = d.urls.full;
                        params.source = UNSPLASH;
                    }
                    if (props.type === PIXABAY) {
                        params.url = d.largeImageURL;
                        params.previewUrl = d.previewURL;
                        params.source = PIXABAY;
                    }
                    addImageToMedia(params);
                }
            });
        }
        const getFileName = (url) => {
            try {
                if (url) {
                    const fileName = url.split(/[\\/]/).pop();
                    return fileName !== null && fileName !== void 0 ? fileName : '';
                }
            }
            catch (error) {
                console.error('Failed url: ', url);
                console.error(error);
                return '';
            }
        };
        const addImageToMedia = (params) => __awaiter(this, void 0, void 0, function* () {
            try {
                yield MediaServices.addFile(params);
                sendNotification({
                    title: t('common.successfullyAdded'),
                    type: 'success',
                });
            }
            catch (error) {
                sendNotification({
                    title: t('common.failedToAddMedia'),
                    type: 'error',
                });
            }
        });
        const tableActions = {
            getLink: {
                label: 'Get link',
                key: 'getLink',
                icon: renderIcon(Link02Icon),
            },
            moveToFolder: {
                label: 'Move to folder',
                key: 'moveFolder',
                icon: renderIcon(FolderIcon),
            },
            delete: {
                label: 'Delete File',
                key: 'delete',
                icon: renderIcon(Trash01Icon),
            },
            rename: {
                label: 'Rename',
                key: 'rename',
                icon: renderIcon(TextInputIcon),
            },
            _divider: {
                type: 'divider',
                key: 3,
            },
            download: {
                label: t('common.download'),
                key: 'download',
                icon: renderIcon(Download01Icon),
            },
            addImageToMedia: {
                label: t('common.addImageToMedia'),
                key: 'addImageToMedia',
                icon: renderIcon(FolderIcon),
            },
        };
        const tableCol = [
            // {
            //   type: 'selection',
            // },
            {
                title: 'Media',
                key: 'media',
                render(row) {
                    return h(TableImage, {
                        file: row,
                        type: props.type,
                    });
                },
            },
            {
                title: 'Name',
                key: 'name',
                render(row) {
                    return h(UITextSmMedium, {
                        class: 'text-gray-900',
                    }, {
                        default: () => {
                            if (props.type === 'file' || props.type === 'static')
                                return row.name;
                            if (props.type === PIXABAY)
                                return getFileName(row.previewURL);
                            if (props.type === UNSPLASH)
                                return row.id;
                        },
                    });
                },
            },
            {
                title: 'Uploaded On',
                key: 'uploadedOn',
                render(row) {
                    return h(UITextSmMedium, {
                        class: 'text-gray-900',
                    }, {
                        default: () => {
                            if (props.type === 'file')
                                return formatDate(row.createdAt);
                            if (props.type === PIXABAY || props.type === 'static')
                                return '-';
                            if (props.type === UNSPLASH)
                                return formatDate(row.created_at);
                        },
                    });
                },
            },
            {
                title: 'File size',
                key: 'fileSize',
                render(row) {
                    return h(UITextSmMedium, {
                        class: 'text-gray-900',
                    }, {
                        default: () => {
                            if (props.type === 'file')
                                return formatBits(row.size);
                            if (props.type === PIXABAY)
                                return formatBits(row.imageSize);
                            if (props.type === UNSPLASH || props.type === 'static')
                                return '-';
                        },
                    });
                },
            },
            {
                title: 'Action',
                key: 'actions',
                render(row) {
                    return h(UIActionDropdown, {
                        options: tableAction(props.type),
                        onSelect: val => onActionsClick(val, row),
                        id: 'table1-drop',
                    }, {});
                },
            },
        ];
        const tableAction = type => {
            if (type === 'file') {
                if (store.mediaModal)
                    return [
                        tableActions.getLink,
                        tableActions.moveToFolder,
                        tableActions.rename,
                        tableActions._divider,
                        tableActions.delete,
                    ];
                return [
                    tableActions.getLink,
                    tableActions.moveToFolder,
                    tableActions.rename,
                    tableActions.download,
                    tableActions._divider,
                    tableActions.delete,
                ];
            }
            else if (type === PIXABAY || type === UNSPLASH) {
                return [tableActions.getLink, tableActions.addImageToMedia];
            }
            else if (type === 'static') {
                if (store.mediaModal)
                    return [tableActions.getLink];
                return [tableActions.getLink, tableActions.download];
            }
        };
        const pageChange = e => {
            emit('pageChange', e - 1);
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(UITable), {
                id: "identifier.BlogList_Table",
                data: _ctx.files,
                columns: tableCol,
                enableTextSearch: false,
                "page-count": Math.ceil(_ctx.count / 10),
                "onUpdate:page": pageChange,
                loading: loading.value
            }, _createSlots({
                empty: _withCtx(() => [
                    _createVNode(NoFile)
                ]),
                _: 2 /* DYNAMIC */
            }, [
                (_ctx.type === _unref(PIXABAY) || _ctx.type === _unref(UNSPLASH) || _ctx.type === 'static')
                    ? {
                        name: "pagination",
                        fn: _withCtx(() => []),
                        key: "0"
                    }
                    : undefined
            ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["data", "page-count", "loading"]));
        };
    }
});
